"use client";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import type { ModalInputProp } from "../../../class/frontend.schema";
export default function TextAreaInput({
  value,
  placeholder,
  setValueFunc,
}: ModalInputProp) {
  const [textVal, setTextVal] = useState(value);
  const [invalid, setInvalid] = useState(false);
  const onChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (event.target.value.toString().length > 0) {
      setInvalid(false);
    }
    setTextVal(event.target.value);
    setValueFunc(event.target.value);
  };

  useEffect(() => {
    setTextVal(value as string);
  }, [value]);

  return (
    <Form.Group className="mb-3" controlId="eventModal.Description">
      <Form.Control
        value={textVal as string}
        as="textarea"
        placeholder={placeholder}
        rows={5}
        style={{ resize: "none" }}
        onChange={onChange}
      />
    </Form.Group>
  );
}
